import { css, keyframes } from 'emotion';

export const loading = keyframes`
  0%, 60%, 100% {
    transform: scale(0.6);
  }

  30% {
    transform: scale(1);
  }
`;

export const circle = css`
  width: 14px;
  height: 14px;
  border-radius: 100%;
  margin-right: 4px;
`;

export const circleLoading = css`
  animation: 1s ${loading} ease-in-out infinite;
  transform-origin: 7px 7px;

  &:nth-child(2) {
    animation-delay: 200ms;
    transform-origin: center center;
  }

  &:nth-child(3) {
    animation-delay: 400ms;
    transform-origin: 42px 7px;
  }
`;
